import React from "react";
import { getAllSiteDraftList, moveSiteDraftToSite } from "../../api/index";
import { Table, Spin, Tag, Button, Popconfirm, message } from "antd";
import { EditFilled, BranchesOutlined } from "@ant-design/icons";
import { useHistory } from 'react-router-dom';

const AllDrafts = () => {

    const [drafts, setDrafts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [selectedSite, setSelectedSite] = React.useState(null);

    const history = useHistory();

    React.useEffect(() => {
        const fetchDraftList = async () => {
            setLoading(true);
            try {
                const response = await getAllSiteDraftList();
                setDrafts(response?.data || []);
            } catch (error) {
                console.error("Error fetching draft list:", error);
            }
            setLoading(false);
        };
        fetchDraftList();
    }, []);

    const moveSite = async (draftId) => {
        try {
            const formData = new FormData();
            formData.append('id', draftId);
            const response = await moveSiteDraftToSite(formData);
            if (response && response.success) {
                message.success("Draft moved successfully");
                const updatedDrafts = drafts.filter(d => d.id !== draftId);
                setDrafts(updatedDrafts);
            } else {
                message.error(response?.message || "Failed to move draft");
            }
        } catch (error) {
            message.error("Error occurred while moving draft");
        }
    }

    const cols = [
        { title: "Site ID", dataIndex: "siteId", key: "siteId" },
        { title: "Site Name", dataIndex: "siteName", key: "siteName", render: (text) => text || "Site Name Not Available" },
        {
            title: "Moveable", dataIndex: "moveable", key: "moveable", render: (text) => text ?
                <Tag color="green" className="textStyles-small" style={{ borderColor: 'whitesmoke', borderRadius: 8, padding: 5, fontWeight: 500, fontSize: 12 }} >Yes</Tag> :
                <Tag className="textStyles-small" style={{ borderColor: 'whitesmoke', borderRadius: 8, padding: 5, fontWeight: 500, fontSize: 12 }} color="red">No</Tag>
        },
        { title: "Missing Fields", dataIndex: "needTofill", key: "needTofill" },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (text, record) => (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Button
                        type="primary"
                        style={{ backgroundColor: '#F28502', borderColor: '#F28502' }}
                        shape='circle'
                        icon={<EditFilled />}
                        size="small"
                        onClick={() => history.push(`/site/update/${record.id}/drafts`)}
                    />

                    {record?.moveable ? (
                        <Popconfirm
                            title={<span className="textStyles-small" style={{ fontSize: 12 }}>
                                Are you sure you want to move this draft to a live site?</span>}
                            onConfirm={() => moveSite(record.id)}
                            okText={<span className="textStyles-small" style={{ fontSize: 12 }}>Yes,</span>}
                            cancelText={<span className="textStyles-small" style={{ fontSize: 12 }}>No</span>}
                            className="textStyles-small"
                            style={{ fontSize: 12 }}
                        >
                            <Button type="default"
                                style={{ borderColor: '#BA183A', backgroundColor: '#BA183A' }}
                                shape="circle"
                                icon={<BranchesOutlined style={{ color: 'white', fontSize: 12 }} />} size="small" />
                        </Popconfirm>
                    ) : null}
                </div>
            )
        }
    ];


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">
                                    <span className="textStyles-small" style={{ fontSize: 16 }}>All Drafts</span>
                                </h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Site View</span>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>All Drafts</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: 15 }}>
                <div style={{ padding: '20px 20px 20px 20px' }}>

                    {/* <div style={{ marginBottom: 16, width: '400px', float: 'right' }}>
                        <Select
                            showSearch
                            allowClear
                            placeholder="Search by site name or site id..."
                            options={siteOptions}
                            value={selectedSite}
                            bordered={false}
                            className='borderedSelect textStyles-small'
                            style={{ width: '400px', height: 38 }}
                            onChange={(val) => setSelectedSite(val)}
                            filterOption={(input, option) => {
                                const label = (option?.label || '').toString().toLowerCase();
                                const value = (option?.value || '').toString().toLowerCase();
                                return label.includes(input.toLowerCase()) || value.includes(input.toLowerCase());
                            }}
                        />
                    </div> */}

                    <Table
                        columns={cols}
                        dataSource={drafts}
                        className="table-striped-rows textStyles-small clickable-row"
                        rowKey="id"
                        loading={loading ? { indicator: <Spin size="large" /> } : false}
                        pagination={{ pageSize: drafts.length > 10 ? 10 : drafts.length }}
                        // onRow={(record) => ({
                        //     onClick: () => history.push(`/site/update/${record.id}`),
                        // })}
                        rowClassName={() => 'cursor-pointer'}
                    />
                </div>
            </div>
        </div>
    );
};

export default AllDrafts;